import React from "react";
import { createRoot } from "react-dom/client";
import './styles/index.css'
import * as dayjs from 'dayjs'
// import * as isLeapYear from 'dayjs/plugin/isLeapYear' // import plugin
import { initSentry } from "@utils/sentry";
import MainApp from "./App";
import 'dayjs/locale/es' // import locale

// dayjs.extend(isLeapYear) // use plugin
dayjs.locale('es') // use locale

// Initialize Sentry
initSentry();
const container = document.getElementById("root");
// eslint-disable-next-line
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <MainApp />
  </React.StrictMode>,
);
